<template>
	<div id="app">
		<router-view ref="view" />
	</div>
</template>

<script>
export default {
	name: 'App',
	created() {
		let urlObj = bmTooljs.getUrlParams(window.location.href)
		if (urlObj.from) {
			bmStorage.localStorage.set('from', urlObj.from)
		} else {
			// this.$message({
			// 	type: 'warning',
			// 	message: '未取得url来源参数, 请检查跳往此项目的url是否正确'
			// })

			// 没有参数跳转到首页
		}
	}
}
</script>

<style lang="less">
@import 'assets/baseStyle/reset.less';
@import 'assets/baseStyle/publicComponents.less';

#app {
	height: 100%;
	position: relative;
}

.el-loading-spinner {
	i {
		color: white;
	}
	.el-loading-text {
		color: white;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue